import { Typography, type TypographyProps } from '@material-tailwind/react';
import { classNames } from '@src/utils/classNames';

export const Skeleton = (
  props: Partial<Pick<TypographyProps, 'as' | 'variant' | 'className'>>,
) => {
  let knownSizeClasses = '';
  switch (props.as) {
    case 'h1':
      knownSizeClasses = 'h-8 lg:h-14';
      break;
    case 'h2':
      knownSizeClasses = 'h-6 md:h-8 lg:h-10';
      break;
    case 'h3':
      knownSizeClasses = 'h-5 lg:h-8';
      break;
    case 'h4':
      knownSizeClasses = 'h-5 lg:h-7';
      break;
    case 'h5':
      knownSizeClasses = 'h-5 lg:h-4';
      break;
    case 'button':
      knownSizeClasses = 'h-12 rounded-xl w-40';
      break;
    default:
      knownSizeClasses = 'h-5 w-65';
      break;
  }

  return (
    // @ts-expect-error There are no attributes missing
    <Typography
      as="div"
      variant="paragraph"
      {...props}
      className={classNames(
        'animate-pulse w-56 rounded-sm bg-gray-300',
        knownSizeClasses,
        props.className,
      )}
    >
      &nbsp;
    </Typography>
  );
};
